module.exports = __webpack_public_path__ + "prod/20260721094810/img/service.edbff227.png";